import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { CreditsContext } from "@utils/GlobalContext.js";
import { ModalPricesAndPlans } from "@webkit/components/typescript/ModalPricesAndPlans";
import paymentService from "@services/payment.service";
import Credits from "@assets/images/credits.jpeg"
import { t } from "i18next";


type Mode = "buy" | "add" | "renew";

const PricesAndPlansPage: React.FC = () => {
  const creditsCtx = useContext(CreditsContext);
  const [openMode, setOpenMode] = useState<Mode | null>(null);
  const [currencies, setCurrencies] = useState([])

  const formatEuro = (value: number, currency: string) => {
    if (!currency || currency.length !== 3) {
      return `${(value / 100).toFixed(2)} EUR`;
    }
    try {
      return (value / 100).toLocaleString("it-IT", {
        style: "currency",
        currency: currency
      });
    } catch (error) {
      console.error('Errore formattazione valuta:', error);
      return `${(value / 100).toFixed(2)} ${currency}`;
    }
  };

  useEffect(() => {
    if (!creditsCtx?.refreshCredits) return;

    const onWindowFocus = () => {
      setOpenMode(null)
      creditsCtx.refreshCredits();
    };

    window.addEventListener("focus", onWindowFocus);
    
    return () => {
      window.removeEventListener("focus", onWindowFocus);
    };
  }, [creditsCtx?.refreshCredits]);

  const getAllCurrency = async () => {
    try {
      const res = await paymentService.getAllCurrency();
      setCurrencies(res);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getAllCurrency()

    const functionRefreshInfo = async () => {
      await creditsCtx.refreshCredits();
    }

    functionRefreshInfo()
  }, [])

  if (creditsCtx?.isLoading) {
    return (
      <div className="p-4 d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Caricamento...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 mx-4">

      <div className='d-flex flex-column justify-content-center'>
        <h2 style={{ color: "var(--primary-color)", marginBottom: "16px", width: "90%" }}>{t('title.prices_plans')}</h2>
        <p>{t("page_description.credits_and_planes")}</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column'}} className='relative'>
        <div className="card shadow-lg" style={{ width: '100%', borderRadius: '25px' }}>
          <div
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: "var(--primary-color)", borderTopLeftRadius: '25px', borderTopRightRadius: '25px' }}
          >
            <h4 className="text-white my-2">{t("title.credits_management")}</h4>
          </div>
          <div className="d-flex flex-row">

            <div className="d-flex flex-column justify-content-center align-items-center w-50 my-4 mx-2">
              {creditsCtx?.orderNumber !== null && creditsCtx?.orderNumber !== '0' ?
                <div style={{ backgroundImage: `url(${Credits})`, backgroundSize:"cover"}} className="w-100 h-100">
                  <div style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }} className="p-5">
                    <p><b>Crediti totali: {creditsCtx?.totalCredits}</b></p>
                    <p><b>Crediti disponibili: {creditsCtx?.creditsRemain}</b></p>
                    <p><b>Scadenza pacchetto: {creditsCtx?.expirationDate?.split('T')[0] ?? ''}</b></p>
                    <p><b>Costo ultima spesa: {formatEuro(creditsCtx?.price, creditsCtx?.currency)}</b></p>
                  </div>
                </div>
                : <img src={Credits} alt="" className="w-75 h-100" />}
            </div>

            <div className="d-flex flex-column w-50 my-4 mx-2 justify-content-center align-items-center">
              <div>
                {creditsCtx?.orderNumber === null || creditsCtx?.orderNumber === '0' ? t("text.buy_credits") : t("text.buy_renewal_add_credits")}
              </div>
              <div className="d-flex flex-column mt-4 w-100 mx-2 justify-content-center align-items-center row-gap-3">
                {creditsCtx?.orderNumber === null || creditsCtx?.orderNumber === '0'? <Button className="w-50" onClick={() => setOpenMode("buy")}>
                  {t("label.buy_pack")}
                </Button> : <></>}
                {creditsCtx?.orderNumber !== null && creditsCtx?.orderNumber !== '0'? <Button className="w-50" onClick={() => setOpenMode("add")}>
                  {t("label.add_credits")}
                </Button> : <></>}
                {creditsCtx?.orderNumber !== null && creditsCtx?.orderNumber !== '0'? <Button className="w-50" style={{ backgroundColor: "var(--primary-color)", border: "0px" }} onClick={() => setOpenMode("renew")}>
                  {t("label.Renewal")}
                </Button> : <></>}
              </div>
            </div>

          </div>
          <div
            className="card-footer"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: "white", borderBottomLeftRadius: '25px', borderBottomRightRadius: '25px' }}
          ></div>
        </div>
      </div>
      <ModalPricesAndPlans
        visible={openMode !== null}
        onClose={() => {
          setOpenMode(null)
          //creditsCtx.refreshCredits()
        }
        }
        mode={openMode ?? "buy"}
        totalCredits={creditsCtx?.totalCredits ?? 0}
        maxCredits={100}
        orderNumber={creditsCtx?.orderNumber}
        currencies={currencies}
        onSuccess={() => {
          creditsCtx.refreshCredits()
        }}
      />
    </div>
  );
};

export default PricesAndPlansPage;
